import React from "react";
import queryString from "query-string";
import styled from "styled-components";

import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getClientById } from "../../../../store/clients/actions";
import DynamicFormToFilterUpdated from "../../../../components/forms/DynamicFormToFilterUpdated";
import {
  getReportRentWidgets,
  getReportRentStats,
  setReportRentWidgets,
  setReportRentStats,
} from "../../../../store/reporting/actions";
import {
  DEFAULT_REPORT_WIDGET_FIRST,
  formatNumbersForTable,
  getSelectedMonthAgoWithFirstDay,
  getSelectedMonthAgoWithLastDay,
} from "../../../../helpers/utils";
import MiniWidget from "../../../../components/MiniWidget/index";
import CustomCurrencySelect from "../../../../components/CustomCurrencySelect/CustomCurrencySelect";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import { INITIAL_DATA_PARAMS } from "../../../../constants/store";
import CustomBreadcrumbsNoLinks from "../../../../components/Common/CustomBreadcrumbsNoLinks";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

const spinnerWidget = (
  <div className="loader-for-react-widget">
    <div className="spinner-border text-primary m-1" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const activeStats = {
  media_source: "media_source",
  cabinet: "cabinet",
  campaign: "campaign",
};

const currencyArr = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
];

const styleNumbers = {
  textAlign: "center",
  width: "auto",
  verticalAlign: "middle",
};

const defaultColumns = [
  {
    Header: "Payment",
    src: "payment",
    accessor: row => formatNumbersForTable(row.payment),
    isSorted: true,
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
  },
  {
    Header: "Spend",
    src: "spend",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.spend),
    isSorted: true,
  },
  {
    Header: "Profit",
    src: "profit",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.profit),
    isSorted: true,
  },
  {
    Header: "Clicks",
    src: "clicks",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.clicks),
    isSorted: true,
  },
  {
    Header: "Impressions",
    src: "shows",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.shows),
    isSorted: true,
  },
  {
    Header: "CTR",
    src: "CTR",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.CTR) + "%",
    isSorted: true,
  },
  {
    Header: "CPC",
    src: "CPC",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.CPC),
    isSorted: true,
  },
  {
    Header: "CPM",
    src: "CPM",
    style: {
      ...styleNumbers,
      minWidth: 110,
    },
    accessor: row => formatNumbersForTable(row.CPM),
    isSorted: true,
  },
];

const RentStatsMain = props => {
  const [date, setDate] = React.useState({
    start_date: getSelectedMonthAgoWithFirstDay(2),
    end_date: getSelectedMonthAgoWithLastDay(-1),
  });
  const [currency, setCurrency] = React.useState(currencyArr[0]);
  const [active, setActive] = React.useState(activeStats.media_source);
  const [columns, setColumns] = React.useState(null);
  const [breadcrumbsArr, setBreadcrumbsArr] = React.useState([]);
  const location = props.history.location;

  const onChangeFirstTableCol = type => {
    switch (type) {
      case activeStats.media_source: {
        let updColumns = [...defaultColumns];
        updColumns.unshift({
          Header: "Media Source",
          src: "media_source",
          style: {
            ...styleNumbers,
            minWidth: 130,
          },
          accessor: row => (
            <StyledSpan
              className="span-link"
              onClick={() =>
                onChangeInTable(activeStats.cabinet, row.media_source)
              }
            >
              {row.media_source}
            </StyledSpan>
          ),
          isSorted: true,
        });
        setColumns(updColumns);
        break;
      }
      case activeStats.cabinet: {
        let updColumns = [...defaultColumns];
        updColumns.unshift({
          Header: "Cabinet Name",
          src: "cabinet_name",
          style: {
            ...styleNumbers,
            minWidth: 130,
          },
          accessor: row => (
            <StyledSpan
              data-toggle="tooltip"
              className="span-link"
              title={row.campaign_name}
              onClick={() =>
                onChangeInTable(activeStats.campaign, row.cabinet_name)
              }
            >
              {row?.custom_name != null ? row.custom_name : row?.cabinet_name?.length > 23
                ? row?.cabinet_name.substr(0, 23) + "..."
                : row?.cabinet_name}
            </StyledSpan>
          ),
          isSorted: true,
        });
        setColumns(updColumns);
        break;
      }
      case activeStats.campaign: {
        let updColumns = [...defaultColumns];
        updColumns.unshift({
          Header: "Campaing name",
          src: "campaign_name",
          style: {
            ...styleNumbers,
            minWidth: 130,
          },
          accessor: row => (
            <StyledSpan
              data-toggle="tooltip"
              className="span-simple"
              title={row.campaign_name}
            >
              {row?.campaign_name?.length > 23
                ? row?.campaign_name.substr(0, 23) + "..."
                : row?.campaign_name}
            </StyledSpan>
          ),
          isSorted: true,
        });
        setColumns(updColumns);
        break;
      }
    }
  };

  React.useEffect(() => {
    let dt = {};
    let parsedSearch = queryString.parse(props.history.location.search);

    dt.start_date =
      parsedSearch.start_date || getSelectedMonthAgoWithFirstDay(2);
    dt.end_date = parsedSearch.end_date || getSelectedMonthAgoWithLastDay(-1);
    dt.currency = parsedSearch.currency || currency.value;
    dt.count_by = parsedSearch.count_by || active;
    dt.client_id = props.match.params?.client_id;

    if (parsedSearch.media_source) dt.media_source = parsedSearch.media_source;
    if (parsedSearch.cabinet_name) dt.cabinet_name = parsedSearch.cabinet_name;

    setDate({
      start_date: dt.start_date,
      end_date: dt.end_date,
    });

    let formQueryString = queryString.stringify(
      Object.assign(parsedSearch, {
        start_date: dt.start_date,
        end_date: dt.end_date,
        currency: dt.currency,
        count_by: dt.count_by,
      })
    );

    location.search = formQueryString;

    props.history.replace(location);
    props.getClientById(props.match.params?.client_id);
    onChangeInTable(dt.count_by, dt.cabinet_name || dt.media_source || "");
    props.getReportRentWidgets({
      ...dt,
    });
    return () => {
      props.setReportRentWidgets(DEFAULT_REPORT_WIDGET_FIRST);
      props.setReportRentStats(INITIAL_DATA_PARAMS);
      setColumns(null);
    };
  }, []);

  React.useEffect(() => {
    // onChangeFirstTableCol(active)
  }, [props.data, active]);

  const onCurrencyChange = e => {
    if (currency.value != e.value) {
      let parsedSearch = queryString.parse(props.history.location.search);
      let dt = {};

      dt.start_date = parsedSearch.start_date;
      dt.end_date = parsedSearch.end_date;
      dt.currency = e.value;
      dt.client_id = props.match.params?.client_id;
      dt.count_by = active;

      if (parsedSearch.media_source)
        dt.media_source = parsedSearch.media_source;
      if (parsedSearch.cabinet_name)
        dt.cabinet_name = parsedSearch.cabinet_name;

      setCurrency(e);

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: dt.start_date,
          end_date: dt.end_date,
          currency: dt.currency,
        })
      );

      location.search = formQueryString;
      props.history.replace(location);

      props.getReportRentWidgets({
        ...dt,
      });
      props.getReportRentStats({
        ...props.data,
        ...dt,
      });
    }
  };

  const onChangeDate = filters => {
    let parsedSearch = queryString.parse(props.history.location.search);
    let dt = {};
    dt.currency = parsedSearch.currency;
    dt.client_id = props.match.params?.client_id;
    dt.count_by = parsedSearch.count_by;
    dt.start_date = filters.start_date;
    dt.end_date = filters.end_date;

    if (parsedSearch.media_source) dt.media_source = parsedSearch.media_source;
    if (parsedSearch.cabinet_name) dt.cabinet_name = parsedSearch.cabinet_name;

    let formQueryString = queryString.stringify(
      Object.assign(parsedSearch, {
        start_date: dt.start_date,
        end_date: dt.end_date,
      })
    );

    location.search = formQueryString;
    props.history.replace(location);

    setDate({
      start_date: dt.start_date,
      end_date: dt.end_date,
    });

    props.getReportRentStats({
      ...props.data,
      ...dt,
    });
    props.getReportRentWidgets({
      ...dt,
    });
  };

  const onTableChange = change => {
    const parsedSearch = queryString.parse(props.history.location.search);
    props.getReportRentStats({
      ...props.data,
      start_date: parsedSearch.start_date,
      end_date: parsedSearch.end_date,
      currency: parsedSearch.currency,
      client_id: props.match.params?.client_id,
      count_by: active,
      media_source: parsedSearch.media_source,
      cabinet_name: parsedSearch.cabinet_name,
      ordering: change.ordering,
    });
  };

  const onChangeInTable = (next, name) => {
    let parsedSearch = queryString.parse(props.history.location.search);
    
    let dt = {
      ...props.data,
      start_date: parsedSearch.start_date,
      end_date: parsedSearch.end_date,
      currency: parsedSearch.currency,
      client_id: props.match.params?.client_id,
      count_by: next,
    };

    let formQueryString = "";
    switch (next) {
      case activeStats.media_source: {
        delete parsedSearch?.media_source;
        delete parsedSearch?.cabinet_name;
        formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            count_by: next,
          })
        );
        setBreadcrumbsArr([]);
        break;
      }
      case activeStats.cabinet: {
        dt.media_source = name;
        delete parsedSearch?.cabinet_name;
        formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            count_by: next,
            media_source: name,
          })
        );
        setBreadcrumbsArr([
          {
            goto: activeStats.media_source,
            title: "All Media Sources",
          },
          {
            active: true,
            title: name,
          },
        ]);
        break;
      }
      case activeStats.campaign: {
        dt.media_source = parsedSearch.media_source;
        dt.cabinet_name = parsedSearch.cabinet_name;

        formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            count_by: next,
            media_source: dt.media_source,
            cabinet_name: name,
          })
        );

        setBreadcrumbsArr([
          {
            goto: activeStats.media_source,
            title: "All Media Sources",
          },
          {
            goto: activeStats.cabinet,
            title: dt.media_source,
            name: dt.media_source,
          },
          {
            active: true,
            title: name,
          },
        ]);
        break;
      }
    }

    location.search = formQueryString;
    props.history.replace(location);
    setActive(next);
    onChangeFirstTableCol(next);
    props.getReportRentStats({
      ...dt,
    });
  };

  return (
    <>
      <React.Fragment>
        {Object.entries(props.client).length > 0 && (
          <div className="page-content">
          <ModifiedMetaTags title={`${props.client.legal_name || "N/A"} | Mobihunter`} />

            <StyledContainer fluid>
              <Breadcrumbs
                title="Clients"
                breadcrumbItem={props.client.legal_name || "N/A"}
                link="/quality-rent-report"
              />

              <DynamicFormToFilterUpdated
                onFiltersChange={onChangeDate}
                // filtersFields={[]}
                selectedDate={date}
                filtered_by={[]}
                filtered_params={queryString.parse(
                  props.history.location.search
                )}
              />

              <Row>
                <MiniWidget
                  data={props.widgets}
                  loading={props.widgets_loader}
                />
              </Row>
              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <Row className="justify-content-between align-middle">
                        <Col xs={6}>
                          <h4 className="mb-2">All media sources</h4>
                          <CustomBreadcrumbsNoLinks
                            breadcrumbItem={breadcrumbsArr}
                            onChange={onChangeInTable}
                          />
                        </Col>
                        <Col xs={6} className="align-content-end">
                          <Form className="row align-items-center float-end ms-1">
                            <div className="col-sm-auto">
                              <CustomCurrencySelect
                                options={currencyArr}
                                onChange={onCurrencyChange}
                                defaultValue={queryString.parse(
                                  props.history.location.search
                                )}
                              />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                      <Row>
                        {columns != null && (
                          <>
                            {/* {props.data_loader ? (
                              <div style={{ padding: 70 }}>{spinnerWidget}</div>
                            ) : ( */}
                              <ReactTableForm
                                loading={props.data_loader}
                                columns={columns}
                                data={props.data}
                                onTableChange={onTableChange}
                                firstIsSticky
                              />
                            {/* )} */}
                          </>
                        )}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </StyledContainer>
          </div>
        )}
      </React.Fragment>
    </>
  );
};

const StyledSpan = styled.span`
  &.span-link {
    color: #556ee6;
    transition: all 0.3s;

    &:hover {
      color: #4458b8;
    }
  }

  &.span-simple {
  }
`;

const StyledContainer = styled(Container)`
  .loader-for--line-chart {
    transition: opacity 0.3s;
    opacity: 1;
    backdrop-filter: blur(4px);
    display: flex;
    width: 98%;
    height: 350px;
    position: absolute;
    z-index: 1;
  }

  .loader-for-react-widget {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 1;
  }
`;

RentStatsMain.propTypes = {
  history: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      client_id: PropTypes.node,
    }).isRequired,
  }).isRequired,
  data: PropTypes.object.isRequired,
  widgets: PropTypes.array.isRequired,
  data_loader: PropTypes.bool.isRequired,
  widgets_loader: PropTypes.bool.isRequired,
  client: PropTypes.object.isRequired,
  getClientById: PropTypes.func.isRequired,
  getReportRentWidgets: PropTypes.func.isRequired,
  getReportRentStats: PropTypes.func.isRequired,
  setReportRentWidgets: PropTypes.func.isRequired,
  setReportRentStats: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: state.Reporting.reportRentData,
  widgets: state.Reporting.reportRentWidgets,
  data_loader: state.Reporting.rent_stats_loader,
  widgets_loader: state.Reporting.rent_widgets_loader,
  client: state.Clients.client,
});

export default connect(mapStateToProps, {
  getClientById,
  getReportRentWidgets,
  getReportRentStats,
  setReportRentWidgets,
  setReportRentStats,
})(RentStatsMain);
